import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Banner from './Banner';
import Courses from './Courses';
import Explore from './Explore';
import ImpactfulLearning from './ImpactfulLearning';

import BlurBox from '../../Components/BlurBox';
import Meta from '../../Components/Meta';

import { fetchAllCourses } from '../../actions/course';
import { getCourses } from '../../selectors/course';

import './style.css';

class LiveClasses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }

  componentDidMount() {
    this.fetchCourses();
  }

  toogleLoading = () => {
    this.setState(prevState => ({
      isLoading: !prevState.isLoading
    }));
  };

  fetchCourses = async () => {
    try {
      this.toogleLoading();
      await this.props.fetchAllCourses();
      this.toogleLoading();
    } catch (err) {
      this.toogleLoading();
    }
  };

  navaigateToCoursePage = courseKey => {
    this.props.history.push(`/live_classes/${courseKey}`);
  };

  render() {
    const { courses } = this.props;
    const { isLoading } = this.state;
    return (
      <React.Fragment>
        <Meta
          title="Live Classes | Project Based Online Mentorship Programs | Alien Brains Education"
          description="Comprehensive easy to understand Live Online Classroom mentorship training program. 1:1 Mentorship, Live Projects with Career Guidance and Support"
        />
        <Banner />

        <ImpactfulLearning />

        <div id="learn-about-courses">
          <BlurBox loading={isLoading}>
            <Courses
              onCourseClick={this.navaigateToCoursePage}
              courses={courses}
            />
          </BlurBox>
        </div>

        <Explore />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store, props) => {
  return {
    courses: getCourses(store, props)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAllCourses
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveClasses);



// WEBPACK FOOTER //
// ./src/Pages/LiveClasses/index.js